import { render, staticRenderFns } from "./SRTitleListGraphql.vue?vue&type=template&id=3d42f6a0&scoped=true"
import script from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRTitleListGraphql.vue?vue&type=style&index=0&id=3d42f6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d42f6a0",
  null
  
)

export default component.exports